import { useScrollManager } from "@/hooks/common";

/**
 * Route-aware scroll management component
 * The useScrollManager hook internally handles route exclusions
 */
export function ScrollManager() {
  // Always call the hook unconditionally (hooks rules requirement)
  // The hook internally handles excluding chat and project routes
  useScrollManager();

  return null; // This component doesn't render anything
}

export default ScrollManager;
